window.bxslider = require('bxslider/dist/jquery.bxslider.min')
